// Svelte action for the content of a blocking modal. Its layer, the ancestor
// matching `layerSelector`, goes on top of <body> and everything outside it,
// other modals included, is inert while the content is mounted.
export function blockPageBehind(node, layerSelector) {
  const layer = node.closest(layerSelector);

  if (!layer) {
    throw new Error(`blockPageBehind: no ancestor matches "${layerSelector}"`);
  }

  const previousFocus = document.activeElement;

  // Last in <body>: on top of the other modals (same z-index), and out of the
  // app even when the action runs before a portal has moved the layer.
  document.body.appendChild(layer);
  const madeInert = inertOutside(layer);

  return {
    destroy() {
      madeInert.forEach((element) => {
        element.inert = false;
      });

      previousFocus?.focus?.();
    },
  };
}

// The siblings of the element and of each of its ancestors up to <body>.
function inertOutside(element) {
  const madeInert = [];

  for (
    let current = element;
    current !== document.body && current.parentElement;
    current = current.parentElement
  ) {
    for (const sibling of current.parentElement.children) {
      if (sibling === current || sibling.inert) continue;

      sibling.inert = true;
      madeInert.push(sibling);
    }
  }

  return madeInert;
}
